import {
  CarretArrowUpSC,
  CarretArrowDown,
} from '@srcDS/js/components/atoms/icons';

export const iconsAccordion = {
  iconToOpen: CarretArrowDown,
  iconToClose: CarretArrowUpSC,
};
